// extracted by mini-css-extract-plugin
export default {"bankId":"styles_bankId__atKcq","moreInfo":"styles_moreInfo__nsqce"};